module.exports = __webpack_public_path__ + "static/img/sz2.ad39869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/sz2.png
// module id = FikJ
// module chunks = 13